import type { ILitigatorCaseSummary } from "src/interfaces/ComplianceGuide/ILitigatorSearch";
import styles from "./LitigatorSearch.module.css";

interface CaseSummaryProps {
  summary: ILitigatorCaseSummary;
}

function hasText(value: string | null): boolean {
  return !!value && value.trim() !== "";
}

const CaseSummary = ({ summary }: CaseSummaryProps) => {
  // Ordered least-to-most specific, so a reader who stops early still gets the gist. The
  // overview is rendered above without a label — it answers "what is this case", which
  // needs no heading.
  const sections = [
    { label: "Allegations", text: summary.allegations },
    { label: "Evidence described", text: summary.evidence },
    { label: "Relief sought", text: summary.relief },
    { label: "Proposed classes", text: summary.classInfo },
  ].filter((section) => hasText(section.text));

  return (
    <section className={styles["case-summary"]} aria-label="Case summary">
      <h6 className={styles["case-summary-heading"]}>
        Case summary
        <span className={styles["case-summary-provenance"]}>
          generated from the filed complaint
        </span>
      </h6>

      <p className={styles["summary-prose"]}>{summary.overview}</p>

      {sections.map((section) => (
        <div key={section.label} className={styles["summary-section"]}>
          <div className={styles["summary-section-label"]}>{section.label}</div>
          <p className={styles["summary-prose"]}>{section.text}</p>
        </div>
      ))}

      <p className={styles["summary-footnote"]}>
        Describes what the plaintiff alleges — not findings of fact, and not an
        assessment of the merits.
      </p>
    </section>
  );
};

export default CaseSummary;
